import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85px;
  background-color: ${COLORS.line};
`;

export default Footer;
